import Alert from '@amzn/meridian/alert';
import { AlertType } from '@amzn/meridian/alert/alert';
import Toaster from '@amzn/meridian/toaster';
import React, { useEffect, useState } from 'react';

interface ToastProps {
  message: string;
  show: boolean;
  onClose: () => void;
  duration: number;
  type?: AlertType;
}

const TimeoutToast: React.FC<ToastProps> = ({
  message,
  show,
  onClose,
  duration,
  type,
}: ToastProps): React.ReactElement => {
  const [open, setOpen] = useState(show);
  const array = [
    {
      id: Math.random().toString(),
      timeout: duration,
    },
  ];
  const toasts = array;
  const handleClose = (): void => {
    setOpen(false);
    onClose();
  };

  useEffect(() => {
    if (show) {
      setOpen(true);
      setTimeout(() => {
        handleClose();
      }, duration);
    }
  }, [show, duration]);

  return open && message.length > 0 ? (
    <Toaster
      toasts={toasts}
      onCloseToast={handleClose}
      alignmentHorizontal='center'
    >
      {(toast): React.ReactElement => (
        <Alert toast type={type || 'neutral'} onClose={toast.onClose}>
          {message}
        </Alert>
      )}
    </Toaster>
  ) : (
    <> </>
  );
};

export default TimeoutToast;
